import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/hr/fines";

// Fetch Fines
export const fetchFines = createAsyncThunk("fines/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await hrmsGetRequest(API_URL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch fines");
  }
});

// Add Fine
export const addFine = createAsyncThunk("fines/add", async (fineData, { rejectWithValue }) => {
  try {
    const response = await hrmsPostRequest(API_URL, fineData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to add fine");
  }
});

// Update Fine
export const updateFine = createAsyncThunk("fines/update", async ({ id, updatedData }, { rejectWithValue }) => {
  try {
    const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to update fine");
  }
});

// Delete Fine
export const deleteFine = createAsyncThunk("fines/delete", async (id, { rejectWithValue }) => {
  try {
    await hrmsDeleteRequest(`${API_URL}/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to delete fine");
  }
});

const fineSlice = createSlice({
  name: "fines",
  initialState: {
    fines: [],
    status: "idle",
    error: null,
    deleteStatus: "idle",
  },
  reducers: {
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFines.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFines.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.fines = action.payload;
        state.error = null;
      })
      .addCase(fetchFines.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(addFine.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addFine.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.fines.push(action.payload);
        state.error = null;
      })
      .addCase(addFine.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateFine.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateFine.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.fines.findIndex((f) => f.id === action.payload.id);
        if (index !== -1) {
          state.fines[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateFine.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteFine.pending, (state) => {
        state.deleteStatus = "loading";
      })
      .addCase(deleteFine.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.fines = state.fines.filter((f) => f.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteFine.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteStatus: resetFineDeleteStatus } = fineSlice.actions;
export default fineSlice.reducer;